import { ProjectlessWorksheetFields } from '../config/DynamicFormSystemField';

const systemFieldOrder = new Map(
  ProjectlessWorksheetFields.map((field, index) => [field.systemRole, index])
);

const getVisOrder = (field) => {
  const visOrder = Number(field?.visOrder);
  return Number.isFinite(visOrder) && visOrder > 0 ? visOrder : Number.MAX_SAFE_INTEGER;
};

export const normalizeDynamicFormFieldOrder = (fields = []) => {
  return fields
    .map((field, originalIndex) => ({ field, originalIndex }))
    .sort((left, right) => {
      const leftSystemOrder = systemFieldOrder.get(left.field.systemRole);
      const rightSystemOrder = systemFieldOrder.get(right.field.systemRole);
      const leftIsSystemField = leftSystemOrder !== undefined;
      const rightIsSystemField = rightSystemOrder !== undefined;

      if (leftIsSystemField && rightIsSystemField) return leftSystemOrder - rightSystemOrder;
      if (leftIsSystemField) return -1;
      if (rightIsSystemField) return 1;

      return getVisOrder(left.field) - getVisOrder(right.field) || left.originalIndex - right.originalIndex;
    })
    .map(({ field }, index) => ({ ...field, visOrder: index + 1 }));
};

export const moveDynamicFormField = (fields, id, direction) => {
  const orderedFields = normalizeDynamicFormFieldOrder(fields);
  const currentIndex = orderedFields.findIndex((field) => field.id === id);
  const targetIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;

  if (currentIndex < 0 || targetIndex < 0 || targetIndex >= orderedFields.length) return orderedFields;
  if (orderedFields[currentIndex].systemRole || orderedFields[targetIndex].systemRole) return orderedFields;

  const movedFields = [...orderedFields];
  const [movedField] = movedFields.splice(currentIndex, 1);
  movedFields.splice(targetIndex, 0, movedField);

  return movedFields.map((field, index) => ({ ...field, visOrder: index + 1 }));
};
